import { render, staticRenderFns } from "./PaymentMercadoLinkForm.vue?vue&type=template&id=3df160d8"
import script from "./PaymentMercadoLinkForm.vue?vue&type=script&lang=js"
export * from "./PaymentMercadoLinkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports